import { tsc } from '~/tsc';

// TODO: this is inaccurate, it combines identifiers for all supported versions
export const identifiers = {
  ZodMiniOptional: tsc.identifier({ text: 'ZodMiniOptional' }),
  ZodOptional: tsc.identifier({ text: 'ZodOptional' }),
  _default: tsc.identifier({ text: '_default' }),
  and: tsc.identifier({ text: 'and' }),
  array: tsc.identifier({ text: 'array' }),
  bigint: tsc.identifier({ text: 'bigint' }),
  boolean: tsc.identifier({ text: 'boolean' }),
  check: tsc.identifier({ text: 'check' }),
  coerce: tsc.identifier({ text: 'coerce' }),
  date: tsc.identifier({ text: 'date' }),
  datetime: tsc.identifier({ text: 'datetime' }),
  default: tsc.identifier({ text: 'default' }),
  describe: tsc.identifier({ text: 'describe' }),
  email: tsc.identifier({ text: 'email' }),
  enum: tsc.identifier({ text: 'enum' }),
  globalRegistry: tsc.identifier({ text: 'globalRegistry' }),
  gt: tsc.identifier({ text: 'gt' }),
  gte: tsc.identifier({ text: 'gte' }),
  infer: tsc.identifier({ text: 'infer' }),
  int: tsc.identifier({ text: 'int' }),
  intersection: tsc.identifier({ text: 'intersection' }),
  ip: tsc.identifier({ text: 'ip' }),
  ipv4: tsc.identifier({ text: 'ipv4' }),
  ipv6: tsc.identifier({ text: 'ipv6' }),
  iso: tsc.identifier({ text: 'iso' }),
  lazy: tsc.identifier({ text: 'lazy' }),
  length: tsc.identifier({ text: 'length' }),
  literal: tsc.identifier({ text: 'literal' }),
  lt: tsc.identifier({ text: 'lt' }),
  lte: tsc.identifier({ text: 'lte' }),
  max: tsc.identifier({ text: 'max' }),
  maxLength: tsc.identifier({ text: 'maxLength' }),
  min: tsc.identifier({ text: 'min' }),
  minLength: tsc.identifier({ text: 'minLength' }),
  never: tsc.identifier({ text: 'never' }),
  null: tsc.identifier({ text: 'null' }),
  nullable: tsc.identifier({ text: 'nullable' }),
  number: tsc.identifier({ text: 'number' }),
  object: tsc.identifier({ text: 'object' }),
  optional: tsc.identifier({ text: 'optional' }),
  parseAsync: tsc.identifier({ text: 'parseAsync' }),
  readonly: tsc.identifier({ text: 'readonly' }),
  record: tsc.identifier({ text: 'record' }),
  regex: tsc.identifier({ text: 'regex' }),
  register: tsc.identifier({ text: 'register' }),
  string: tsc.identifier({ text: 'string' }),
  time: tsc.identifier({ text: 'time' }),
  tuple: tsc.identifier({ text: 'tuple' }),
  undefined: tsc.identifier({ text: 'undefined' }),
  union: tsc.identifier({ text: 'union' }),
  unknown: tsc.identifier({ text: 'unknown' }),
  url: tsc.identifier({ text: 'url' }),
  uuid: tsc.identifier({ text: 'uuid' }),
  void: tsc.identifier({ text: 'void' }),
};
